// extracted by mini-css-extract-plugin
module.exports = {"root":"tweet-skeleton_root__q3Obw"};